import { useResponsive } from "../../../core/hooks/useResponsive";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
  Box,
  Paper,
} from "@mui/material";

const OrderLogDialog = ({ open, onClose, orderLog, symbol }) => {
  const { isPhone } = useResponsive();
  return (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
    fullScreen={isPhone}
    PaperProps={{ sx: { borderRadius: isPhone ? 0 : 2 } }}
  >
    <DialogTitle sx={{ px: { xs: 1.75, sm: 3 }, py: { xs: 1.25, sm: 2 } }}>
      <Typography variant={isPhone ? "subtitle1" : "h6"} fontWeight={800} noWrap>
        Order Log - {symbol || "N/A"}
      </Typography>
    </DialogTitle>
    <DialogContent sx={{ px: { xs: 1.25, sm: 3 } }}>
      {orderLog && orderLog.length > 0 ? (
        <Paper variant="outlined" sx={{ mt: 1 }}>
          <List dense>
            {orderLog.map((log, index) => (
              <ListItem key={index} divider={index < orderLog.length - 1}>
                <ListItemText primary={log} primaryTypographyProps={{ variant: "body2" }} />
              </ListItem>
            ))}
          </List>
        </Paper>
      ) : (
        <Box sx={{ py: 3, textAlign: "center" }}>
          <Typography variant="body2" color="text.secondary">
            No order log available
          </Typography>
        </Box>
      )}
    </DialogContent>
    <DialogActions sx={{ px: { xs: 1.75, sm: 3 }, pb: { xs: 1.5, sm: 2 } }}>
      <Button onClick={onClose} variant="contained" color="primary" fullWidth={isPhone}>
        Close
      </Button>
    </DialogActions>
  </Dialog>
  );
};

export default OrderLogDialog;
